import { Grid2 } from '@mui/material';
import React from 'react';

import { usePageContext } from '@contexts/page-context';

import { useAdminGetPermission } from 'generated/admin.generated';

import MetadataEditor from './MetadataEditor';

interface PermissionDrilldownProps {
  permission_id: string;
}

const PermissionDrilldown = ({
  permission_id,
}: React.PropsWithChildren<PermissionDrilldownProps>) => {
  const { data, loading } = useAdminGetPermission({
    variables: { input: { permission_id } },
  });
  const { setTitle } = usePageContext();

  const permission = data?.getPermission;

  React.useEffect(() => {
    if (permission?.permission_name) {
      setTitle(permission.permission_name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permission?.permission_name]);

  return (
    <Grid2 container spacing={1}>
      <Grid2 size={{ xs: 12, sm: 6 }}>
        <MetadataEditor loading={loading} permission={permission} />
      </Grid2>
    </Grid2>
  );
};

export default PermissionDrilldown;
